<div
  class="card-content"
  [ngClass]="{ 'card-pink': color === 'pink', 'card-blue': color === 'blue' }"
>
  <div class="card-img">
    <img src="{{ img }}" />
  </div>
  <div class="card-title">{{ title | translate }}</div>
  <div class="card-description">
    <div
      *ngFor="let el of getDescriptionAsArray()"
      class="d-flex align-items-center"
    >
      <img *ngIf="icon" width="10%" src="../../../assets/icon/right.png" />
      <div>
        {{ el | translate }}
      </div>
    </div>
  </div>
</div>
